import axios from "axios";

export const fetchReports = (reportType, callback) => {
  axios.get(`/api/reports?report_type=${reportType}`)
    .then(res => callback(res))
    .catch(err => callback(err.response));
};

export const createReport = (reportType, filters, callback) => {
  axios.post("/api/reports", {
    report_type: reportType,
    filters: filters
  }, {
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(res => callback(res))
    .catch(err => callback(err.response));
};

export const fetchPublicationsForReport = (callback) => {
  axios.get("/api/publication_bases?report_filter=true")
    .then(res => callback(res))
    .catch(err => callback(err.response));
};